import React, { useState, useEffect, useRef } from 'react';
import { db } from '../lib/firebase'; // Import Firestore instance
import { collection, addDoc } from 'firebase/firestore'; // Import Firestore functions

const ContactForm = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    construction_type: '',
    budget_range: '',
    location: '',
    preferred_date: '',
    message: '',
    priority: 'medium'
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const contactWrapRef = useRef(null);
  const contactOverlayCloseRef = useRef(null);
  const contactModalWrapRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      contactOverlayCloseRef.current?.classList.add('active');
      contactModalWrapRef.current?.classList.add('slide-in');
    } else {
      document.body.style.overflow = '';
      contactOverlayCloseRef.current?.classList.remove('active');
      contactModalWrapRef.current?.classList.remove('slide-in');
      // Reset form on close after animation
      setTimeout(() => {
        setIsSubmitting(false);
        setIsSubmitted(false);
        setFormData({
            name: '',
            company: '',
            email: '',
            phone: '',
            construction_type: '',
            budget_range: '',
            location: '',
            preferred_date: '',
            message: '',
            priority: 'medium'
        });
      }, 500);
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
        ...prev,
        [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;

    // Validate required fields
    if (!formData.name || !formData.email || !formData.phone || 
        !formData.construction_type || !formData.budget_range || !formData.location) {
      alert('모든 필수 항목(*)을 입력해주세요.');
      return;
    }

    setIsSubmitting(true);
    try {
      await addDoc(collection(db, "contacts"), {
        ...formData,
        created_at: new Date().toISOString(),
        status: 'new',
        updated_at: new Date().toISOString()
      });
      console.log("Document successfully written!");
      setIsSubmitted(true);
    } catch (error) {
      console.error("Error writing document: ", error);
      alert('상담 신청 중 오류가 발생했습니다: ' + error.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="contact_wrap" ref={contactWrapRef}>
      <div className="code-embed w-embed">
        {/* Styles can be moved to a CSS file if preferred */}
      </div>
      <div className="contact_overlay_close" ref={contactOverlayCloseRef} onClick={onClose}></div>
      <div className="contact_modal_wrap" ref={contactModalWrapRef}>
        <div className="contact_header_wrap">
          <div className="contact_header_content">
            <div data-lines-split="" className="contact_header_eyebrow">
              <div data-wf--global-eyebrow--variant="white"
                className="g_eyebrow u-text-small w-variant-8a6771b6-7ce3-92e9-1b03-e3b390624011">건축/인테리어 상담</div>
            </div>
            <p data-lines-split="" className="contact_header_paragraph u-text-main is-header">저희와 함께 만들고 싶은 공간에 대해 몇 가지 세부 사항을 알려주세요. 아래 양식을 작성해 주시면, 저희가 고객님의 프로젝트에 가장 적합한 파트너인지 검토해 볼 수 있습니다. <br />
              032-211-4896, 010-3881-4896</p>
          </div>
          <div className="contact_header_aside">
            <button data-link-hover="" data-contact-close="" className="menu_navbar_close" onClick={onClose}>
              <div data-link="" className="menu_navbar_text u-text-small">닫기</div>
            </button>
            {/* <div data-image-reveal-noscroll="" data-orientation="portrait" className="contact_header_cover">
              <div data-image-cover="" className="g_image_cover"></div><img
                src="../assets/images/Image_fx (94).jpg"
                loading="lazy" data-image="" alt="" className="contact_header_image" />
            </div> */}
          </div>
        </div>
        <div sf-step-animation-ease="cubic-bezier(0.42, 0, 0.58, 1)" sf="form" sf-step-animation-duration="300"
          className="contact_form_wrap">
            {isSubmitted ? (
                <div className="success_wrap w-form-done" style={{display: 'block'}}>
                    <p className="success_paragraph u-text-h3">상담 신청이 성공적으로 접수되었습니다.<br/>담당자가 곧 연락드리겠습니다.</p>
                </div>
            ) : (
          <div className="contact_form_contain w-form">
            <form id="wf-form-Enquiry-Form" name="wf-form-Enquiry-Form" data-name="Enquiry Form" onSubmit={handleSubmit}
              className="contact_form_main">
              {/* Personal Info */}
              <div sf-step="personal" className="contact_form_group">
                <div className="contact_form_group_top">
                  <div className="contact_form_group_title u-text-small">
                    <div className="g_eyebrow u-text-small">기본 정보</div>
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="name" className="contact_field_label u-text-small">고객명 <span className="u-required">*</span></label>
                    <input className="contact_field_input w-input" name="name" value={formData.name} onChange={handleChange} placeholder="이름" type="text" id="name" required />
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="company" className="contact_field_label u-text-small">회사명</label>
                    <input className="contact_field_input w-input" name="company" value={formData.company} onChange={handleChange} placeholder="회사명" type="text" id="company" />
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="email" className="contact_field_label u-text-small">이메일 <span className="u-required">*</span></label>
                    <input className="contact_field_input w-input" name="email" value={formData.email} onChange={handleChange} placeholder="example@email.com" type="email" id="email" required />
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="phone" className="contact_field_label u-text-small">전화번호 <span className="u-required">*</span></label>
                    <input className="contact_field_input w-input" name="phone" value={formData.phone} onChange={handleChange} placeholder="010-1234-5678" type="tel" id="phone" required />
                  </div>
                </div>
              </div>
              
              {/* Project Details */}
              <div sf-step="projectDetails" className="contact_form_group" style={{marginTop:'10px'}}>
                <div className="contact_form_group_top">
                  <div className="contact_form_group_title u-text-small">
                     <div className="g_eyebrow u-text-small">프로젝트 정보</div>
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="construction_type" className="contact_field_label u-text-small">인테리어 유형 <span className="u-required">*</span></label>
                    <select
                      id="construction_type"
                      name="construction_type"
                      value={formData.construction_type}
                      onChange={handleChange}
                      className="contact_field_input w-input"
                      required
                    >
                      <option value="">선택하세요</option>
                      <option value="주거공간">주거공간</option>
                      <option value="상업공간">상업공간</option>
                      <option value="오피스">오피스</option>
                      <option value="기타">기타</option>
                    </select>
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="budget_range" className="contact_field_label u-text-small">예산 범위 <span className="u-required">*</span></label>
                    <select
                      id="budget_range"
                      name="budget_range"
                      value={formData.budget_range}
                      onChange={handleChange}
                      className="contact_field_input w-input"
                      required
                    >
                      <option value="">선택하세요</option>
                      <option value="5천만원 미만">5천만원 미만</option>
                      <option value="5천만원 ~ 1억원">5천만원 ~ 1억원</option>
                      <option value="1억원 ~ 3억원">1억원 ~ 3억원</option>
                      <option value="3억원 이상">3억원 이상</option>
                    </select>
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="location" className="contact_field_label u-text-small">위치 <span className="u-required">*</span></label>
                    <input className="contact_field_input w-input" name="location" value={formData.location} onChange={handleChange} placeholder="서울특별시 강남구" type="text" id="location" required />
                  </div>
                  <div className="contact_form_group_field">
                    <label htmlFor="preferred_date" className="contact_field_label u-text-small">희망 상담일</label>
                    <input className="contact_field_input w-input" name="preferred_date" value={formData.preferred_date} onChange={handleChange} type="date" id="preferred_date" />
                  </div>
                </div>
              </div>

              {/* Design Brief */}
              <div sf-step="designBrief" className="contact_form_group" style={{marginTop: '10px'}}>
                <div className="contact_form_group_top">
                    <div className="contact_form_group_title u-text-small">
                        <div className="g_eyebrow u-text-small">문의 내용</div>
                    </div>
                    <div className="contact_form_group_field">
                        <label htmlFor="message" className="contact_field_label u-text-small">추가 요청사항</label>
                        <textarea placeholder="프로젝트에 대해 알려주세요..." maxLength="5000" id="message" name="message" value={formData.message} onChange={handleChange} className="contact_field_input is-textarea w-input"></textarea>
                    </div>
                </div>
              </div>

              {/* Submission */}
              <div className="contact_form_group_navigation">
                <button data-link-hover="" type="button" onClick={onClose} className="contact_navigation_prev u-text-small">
                  <div data-link="" className="btn_default_text is-prev">취소</div>
                </button>
                <button data-link-hover="" type="submit" className="contact_navigation_next u-text-small" disabled={isSubmitting}>
                  <div data-link="" className="text-black">{isSubmitting ? '전송 중...' : '상담 신청'}</div>
                </button>
              </div>
            </form>
          </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default ContactForm;
